import { HTTP_TOKEN_REPORT } from "./http";

export const getProfit = (params) => {
  return HTTP_TOKEN_REPORT.get("report-profit", { params }).then((result) => {
    return result.data;
  });
};
